import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTarget, setPlace } from './familySlice'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import { selectEventsData, setEventData } from '../events/eventsSlice'
import { browserName } from 'react-device-detect'
import { appendLinksList } from '../../helper/utils'
import ChooseOptionContainer from './ChooseOptionContainer'


const CreatePlace = ({ history }) => {
    const dispatch = useDispatch();
    const target = useSelector(selectTarget);
    const eventsData = useSelector(selectEventsData);
    const BUTTONS = ['work', 'bar', 'restaurant', 'hotel', 'nightclub', 'custom'];

    useEffect(() => {
        appendLinksList('map');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const onContinueClick = (whichPlace) => {
        dispatch(setEventData({ id: 'Place', data: whichPlace }));
        sendAnalyticsEvents(EVENTS.onboardingPlaceSubmitted, {
            ...eventsData,
            Place: whichPlace,
        });
        dispatch(setPlace(whichPlace));
        const skipMap = (browserName === 'Facebook' || browserName === 'Instagram');
        setTimeout(() => history.push(`/${skipMap ? 'signup' : 'add-place'}`), 200)
    };

    return <ChooseOptionContainer title={`be_sure_${target}`}
                                  description={`add_place_description_${target}`}
                                  pageEvent={'onboardingPlace'}
                                  buttons={BUTTONS}
                                  onContinueClick={onContinueClick}
    />
};

export default CreatePlace